import { Link } from "@remix-run/react";

export default function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-[#282723] z-20 bottom-0 mt-auto w-full pt-10 pb-[calc(2.5rem+env(safe-area-inset-bottom,0px))]">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} BulkBuyPlace
          </p>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
            <Link
              to="/suppliers"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Browse Stores
            </Link>
            <Link
              to="/sell"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Become a Supplier
            </Link>

            <span className="hidden sm:inline text-gray-600" aria-hidden="true">
              |
            </span>

            <Link
              to="/contact"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Privacy
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
